import styled from 'styled-components'
import { FlexCol, FlexRow } from '@src/styles'

export const PageWrapper = styled<any>(FlexCol)`
  width: 100%;
  min-height: 100vh;
  align-items: stretch;
`

export const ContentWrapper = styled<any>(FlexCol)`
  align-items: flex-start;
  margin-top: 24px;
  width: 100%;
`

export const CategoryDescription = styled.p`
  color: ${props => props.theme.label};
  font-size: 14px;
  margin: 0 0 24px 0;
  line-height: 20px;
`

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid ${props => props.theme.tableBorder || '#333'};
  }

  th {
    color: ${props => props.theme.label};
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  td {
    color: ${props => props.theme.white};
    font-size: 14px;
  }

  tr:hover {
    background: ${props => props.theme.tableRowHover || 'rgba(255, 255, 255, 0.05)'};
  }
`

export const DocumentName = styled.span`
  color: ${props => props.theme.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    text-decoration: underline;
  }

  svg {
    width: 16px;
    height: 16px;
    fill: ${props => props.theme.white};
  }
`

export const CategoryBadge = styled.span<{ category?: string }>`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.theme.secondary || '#1a3d1a'};
  color: ${props => props.theme.white};
`

export const ActionsCell = styled<any>(FlexRow)`
  justify-content: flex-end;
  gap: 8px;
`

export const EmptyState = styled<any>(FlexCol)`
  width: 100%;
  padding: 60px 20px;
  text-align: center;
  align-items: center;

  svg {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
    fill: ${props => props.theme.label};
  }

  h3 {
    color: ${props => props.theme.white};
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  p {
    color: ${props => props.theme.label};
    font-size: 14px;
    margin: 0 0 24px 0;
    max-width: 400px;
  }
`

export const LabelButton = styled.label`
  cursor: pointer;
  margin-right: 20px;
  color: ${props => props.theme.white};
  opacity: 1;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    fill: ${props => props.theme.white};
    height: 16px;
    width: 16px;
  }
`
